import { Button } from "@heroui/react";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { shortHex } from "../../utils";

export function TransferSuccessToast({
  amount,
  tokenSymbol,
  txHash,
  onDismiss,
}: {
  amount?: number;
  tokenSymbol?: string;
  txHash?: string;
  onDismiss: () => void;
}) {
  return (
    <div className="flex gap-4 items-center turnstile-toast-border shadow-xl p-4 rounded-xl text-white fixed bottom-24 right-8 z-50">
      <BadgeCheckIcon className="size-10 stroke-1 text-green-500/90 fill-green-500/10 " />
      <div className="max-w-56">
        <div className="font-semibold">
          {amount && tokenSymbol ? `${amount.toFixed(2)} ${tokenSymbol} is now transferred!` : "Your transfer is complete!"}
        </div>
        {txHash && <div>Txn: {shortHex(txHash)}</div>}
      </div>
      <Button variant="light" isIconOnly onPress={onDismiss} className="text-white">
        <XIcon />
      </Button>
    </div>
  );
}
